const AccountActions = {
  ORDERS_LOADED: "account/orders/loaded",
  INVITATION_LOADED: "account/invitation/loaded",
};

export default AccountActions;
